export const SANITY_TOKEN =
	"sk3EGnPuHalUCokigTHpJFr06SiF1bdhvdl5UwiKbMiMMv9sjSCbKxQBmlfyTgCsjyhLJerGLCqP0fZJRici0S30dIkuUxfkAmCU06UsHIIzBplFO93OQBiiGJrWzw0YwbFq3ON7uufDCu3prCTWCQWbl0f8InLegyPhwlW833l83p0TaT0F";
export const SANITY_BASE_URL = "https://k3f5v59v.api.sanity.io";
